import { Point, utils } from '@gush/candybar';
const START = 0.02

export default class Demo {
    constructor({ pointerDown, pointerUp }) {
        this.pointerDown = pointerDown;
        this.pointerUp = pointerUp;
        this.c = START;
        this.s = 0.975;
        this.t = 0;
    }

    getOrigin(bounds) {
        const x = bounds.w * 0.5;
        const y = bounds.h * 0.4;
        return new Point(x, y);
    }

    getDestination(bounds) {
        const x = (bounds.w * Math.random()) / 2 + 0.5;
        const y = bounds.h * 0.7;
        return new Point(x, y);
    }

    setup = ({ bounds }) => {
        this.start(bounds);
    };

    start = bounds => {
        this.run = true;
        this.t = 0;
        this.origin = this.getOrigin(bounds);
        this.position = this.origin.clone();
        this.destination = this.getDestination(bounds);
        this.dist = this.origin.distance(this.destination);

        this.pointerDown({
            clientX: this.origin.x,
            clientY: this.origin.y,
        });
    };

    stop = () => {
        this.run = false;
        this.c = START;
        this.pointerUp({
            clientX: this.destination.x,
            clientY: this.destination.y,
        });
    };

    lerp() {
        this.position.moveTo(
            utils.lerp(this.origin.x, this.destination.x, this.t),
            utils.lerp(this.origin.y, this.destination.y, this.t)
        );
        this.c *= this.s;
        this.t += this.c;
    }

    update = ({ tick, bounds }) => {
        if (this.run) {
            if (this.c >= 0.001) {
                this.lerp();
            } else {
                this.stop();
            }
        }

        if (tick % 200 === 0 && !this.run) {
            this.start(bounds);
        }
    };
}
